import { AppState } from "../../../redux-configuration/AppState";

export const updateBusinessLoadingSelector = (appState: AppState): boolean => appState.registration.updateBusiness.loading
export const updateBusinessErrorSelector = (appState: AppState): string | undefined => appState.registration.updateBusiness.error
export const updateBusinessSuccessSelector = (appState: AppState): boolean | null => appState.registration.updateBusiness.success
